var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg05Profile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x30_5-profile_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222"
    },
    d: "M22.2,9.1C20.9,4.6,16.7,1.6,12,1.5C7.9,1.6,4.1,4,2.4,7.8c-1.8,4.1-0.8,9.1,2.5,12.1 c3.6,3.3,9.1,3.7,13.1,1c0.4-0.2,0.7-0.5,1-0.8c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0,0,0-0.1C22.1,17.2,23.4,13,22.2,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2.8,9.4C4,5.3,7.8,2.6,12,2.5c3.6,0.1,7,2.1,8.6,5.4c1.8,3.6,1.1,7.9-1.6,10.8 c-1-3-3.6-5.2-6.9-5.3C8.8,13.3,6,15.6,5,18.7C2.7,16.2,1.8,12.6,2.8,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M6.1,19.7c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.1,0-0.2c0.9-2.8,3.3-4.7,6.4-4.7 c2.9,0.1,5.1,2.1,6,4.7c0,0,0,0.1,0,0.1c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0,0,0C14.3,22.4,9.6,22.3,6.1,19.7z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.712,
    y1: 9.8064,
    x2: 14.3667,
    y2: 9.8064
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.7,
    y: 7.5,
    style: {
      fill: "url(#SVGID_1_)"
    },
    width: 4.7,
    height: 4.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05Profile);
export default __webpack_public_path__ + "static/media/05-profile.3e8171ff1dd3c7e79787ac88d83e5f81.svg";
export { ForwardRef as ReactComponent };